"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _DepthChartComponent = _interopRequireDefault(require("./DepthChartComponent"));
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _config = _interopRequireDefault(require("../../config"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DepthChart = _config["default"].DepthChart;
var mapStateToProps = function mapStateToProps(state) {
  var level2 = state.apexCore.level2;
  var fetching = level2.fetching;
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  return {
    level2: level2,
    fetching: fetching,
    DepthChart: DepthChart,
    selectedInstrument: selectedInstrument
  };
};
var mapDispatchToProps = {
  buyPriceClicked: _orderEntryActions.buyPriceClicked,
  sellPriceClicked: _orderEntryActions.sellPriceClicked
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DepthChartComponent["default"]);